module.exports = "/lucky-balls/img/infobox/info_Box_018.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/lucky-balls/img/infobox/info_Box_018.png
// module id = 1083
// module chunks = 0